import { defineComponent as _defineComponent } from 'vue'
import { useFeatureFlag } from 'ah-common-stores';
import { FeatureFlag } from 'ah-api-gateways/models/featureFlag';
import OldTradePriceMarginInfo from './tradePriceMarginInfoViews/OldTradePriceMarginInfo.vue';
import TradePriceMarginInfo from './tradePriceMarginInfoViews/TradePriceMarginInfo.vue';

/**
 * FIXME - This component serves the purpose to render the new or old flow of forward trades (US's PT-1828 and PT-1829)
 * This will exist until we remove the VARIATION_MARGIN_AND_LIMITS_FEATURE feature flag
 * After that the old behavior will be removed and we will only keep the new one, but for now we need a fallback
 * */


export default /*#__PURE__*/_defineComponent({
  __name: 'TradePriceMarginInfoView',
  props: {
  boxGridBlockProps: {
    type: Object,
    required: true,
  },
},
  setup(__props) {



const { isActive: isVariationMarginFeatureActive } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});

return { __sfc: true,isVariationMarginFeatureActive, OldTradePriceMarginInfo, TradePriceMarginInfo }
}

})